<div class='other-occupation'>
  <div class='transient-occupation'>
    {{ 'FACILITIES_SUMMARY.FACILITY.TRANSIENTS' | translate }}
    <div class='other-occupation-number'>
      {{ transientOccupation.occupation }}
    </div>
    {{ 'FACILITIES_SUMMARY.FACILITY.WORD_OFF' | translate }}
    {{ transientOccupation.capacity }}
  </div>
  <div class='subscriber-occupation'>
    {{ 'FACILITIES_SUMMARY.FACILITY.SUBSCRIBERS' | translate }}
    <div class='other-occupation-number'>
      {{ subscriberOccupation.occupation }}
    </div>
    {{ 'FACILITIES_SUMMARY.FACILITY.WORD_OFF' | translate }}
    {{ subscriberOccupation.capacity }}
  </div>
  <div *ngIf='customOccupation' class='custom-occupation'
       nbTooltip="{{ customOccupation.type['name'] }}"
       nbTooltipStatus='primary'>
    {{ customOccupation.type['name'] | slice:0:12 }}
    <div class='other-occupation-number'>
      {{ customOccupation.occupation }}
    </div>
    {{ 'FACILITIES_SUMMARY.FACILITY.WORD_OFF' | translate }}
    {{ customOccupation.capacity }}
  </div>
</div>
